import { ModalType } from 'global/TradingModal/RealTradingModal/types';
import { iPreviewData } from 'typings/transactionForm';
import create from 'zustand';

export interface iTradingStoreData {
  previewData?: iPreviewData;
  openModal: ModalType | '';
  symbol?: string;
  orderType?: string;
  formType?: string;
  openFromWidget: boolean;
  autoOrderId?: string;
  autoOrderStatus?: string;
  priceOrder?: number;
  orderOpen?: number;
  orderLabel?: string;
  orderGtc?: number;
  smartOrderId?: string;
  onSubmitAutoOrderTnC?: () => void;
  onSubmitDayTradeTnC?: () => void;
  onSubmitTradingLimitTnC?: () => void;
}

interface ITradingStoreAction {
  setModal: (
    modal: ModalType | '',
    payload?: Partial<iTradingStoreData>,
  ) => void;
  onClose?: () => void;
  resetModal: () => void;
  setSymbol(symbol: iTradingStoreData['symbol']): void;
  setOrderType: (type?: string) => void;
  setFormType: (type?: string) => void;
  setOpenFromWidget: (open: boolean) => void;
  setAutoOrderId: (autoOrderId: string) => void;
}

export type iTradingStore = iTradingStoreData & ITradingStoreAction;

const initialState: iTradingStoreData = {
  openModal: '',
  symbol: null,
  orderType: null,
  formType: null,
  openFromWidget: false,
};

const tradingStore = () =>
  create<iTradingStore>((set) => ({
    ...initialState,
    setModal: (modal, payload) => {
      set({ openModal: modal, ...payload });
    },
    resetModal: () => {
      set(initialState);
    },
    setSymbol: (symbol) => {
      set({ symbol });
    },
    setOrderType: (type) => {
      set({ orderType: type });
    },
    setFormType: (type) => {
      set({ formType: type });
    },
    setOpenFromWidget: (open) => {
      set({ openFromWidget: open });
    },
    setAutoOrderId: (autoOrderId) => {
      set({ autoOrderId });
    },
  }));

export default tradingStore;
